/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from "react";
import LayoutOperationNewJob from "../../../components/LayoutOperationNewJob";
import {
  Table,
  Input,
  Select,
  Modal,
  Tooltip,
  Spin,
  Pagination,
  Image,
  message,
  Radio,
} from "antd";
import Api from "../../../services/ServiceApi";
import Cookies from "js-cookie";
import moment from "moment";
import { throwStatement } from "@babel/types";
import axios from "axios";
import { LoadingOutlined } from "@ant-design/icons";

function createJob(item, active) {
  localStorage.setItem("informDetail", JSON.stringify(item));
  localStorage.setItem("active", active);
  localStorage.setItem("StatusLocal", 2);
  setTimeout(function () {
    window.location.assign("/MaxiOperation/editjob");
  }, 1000);
}

class InformList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "New Job",
      tab: [
        { text: "Not Map" },
        { text: "Approve Job" },
        { text: "Create Job" },
        { text: "Cancel" },
        { text: "Reject" },
        { text: "Hold" },
      ],
      active: 0,
      current_option: 1,
      columns: [
        {
          title: "Incident ID",
          dataIndex: "so_id",
          key: "so_id",
          showSorterTooltip: false,
          sorter: (a, b) => a.so_id.length - b.so_id.length,
        },
        {
          title: "Job Category",
          dataIndex: "JobCategory",
          key: "JobCategory",
          showSorterTooltip: false,
          sorter: (a, b) => a.JobCategory.localeCompare(b.JobCategory),
          ellipsis: {
            showTitle: false,
          },
          render: (item) => (
            <Tooltip placement="topLeft" title={item}>
              {item}
            </Tooltip>
          ),
        },
        {
          title: "Job Type",
          dataIndex: "JobType",
          key: "JobType",
          showSorterTooltip: false,
          sorter: (a, b) => a.JobCategory.length - b.JobCategory.length,
          ellipsis: {
            showTitle: false,
          },
          render: (item) => (
            <Tooltip placement="topLeft" title={item}>
              {item}
            </Tooltip>
          ),
        },
        {
          title: "Sub Type",
          key: "SubType",
          showSorterTooltip: false,
          sorter: (a, b) => a.SubType.localeCompare(b.SubType),
          ellipsis: {
            showTitle: false,
          },
          render: (item) => (
            <Tooltip placement="topLeft" title={item}>
              {!item.SubType ? "-" : item.SubType}
            </Tooltip>
          ),
        },
        {
          title: "Work Center",
          dataIndex: "WorkCenter",
          key: "WorkCenter",
          showSorterTooltip: false,
          sorter: (a, b) => a.WorkCenter.length - b.WorkCenter.length,
          ellipsis: {
            showTitle: false,
          },
          render: (item) => (
            <Tooltip placement="topLeft" title={item}>
              {item}
            </Tooltip>
          ),
        },
        {
          title: "SLA Level",
          dataIndex: "SlaLevel",
          key: "SlaLevel",
          showSorterTooltip: false,
          sorter: (a, b) => a.SlaLevel.length - b.SlaLevel.length,
        },
        {
          title: "Remark",
          dataIndex: "IsReopen",
          key: "IsReopen",
          showSorterTooltip: false,
          sorter: (a, b) => a.IsReopen.length - b.IsReopen.length,
          ellipsis: {
            showTitle: false,
          },
          render: (item) => (
            <Tooltip placement="topLeft" title={item}>
              {item ? "Dtac Reopen" : "-"}
            </Tooltip>
          ),
        },
        {
          title: "Action",
          width: 150,
          align: "center",
          render: (item) => (
            <div>
              {this.state.active === 2 || this.state.active === 3 ? (
                "-"
              ) : (
                <button
                  className="btn-sm btn-success"
                  onClick={() => {
                    if (this.state.tabStatus === "Wait Review Reject") {
                      this.loadDataReview(item);
                    } else {
                      localStorage.setItem("CheckReopen", item.IsReopen);
                      window.location.assign(
                        "/MaxiOperation/CreateJob/" +
                          Cookies.get("companyid") +
                          "/" +
                          Cookies.get("operator_id") +
                          "/" +
                          item.project_id +
                          "/" +
                          item.Id
                      );
                    }
                  }}
                  style={{
                    backgroundColor: "#e8cd00",
                    color: "#fff",
                    border: "1px solid #e8cd00",
                    margin: "2px 0px",
                  }}
                >
                  <img
                    src={Api.absoluteUrl("/icon/approve.svg")}
                    className="mr-2"
                  />
                  Wait Review
                </button>
              )}
            </div>
          ),
        },
      ],
      columnsHold: [
        {
          title: "Incident ID",
          dataIndex: "so_id",
          key: "so_id",
          showSorterTooltip: false,
          sorter: (a, b) => a.so_id.length - b.so_id.length,
        },
        {
          title: "Job Category",
          dataIndex: "JobCategory",
          key: "JobCategory",
          showSorterTooltip: false,
          sorter: (a, b) => a.JobCategory.localeCompare(b.JobCategory),
          ellipsis: {
            showTitle: false,
          },
          render: (item) => (
            <Tooltip placement="topLeft" title={item}>
              {item}
            </Tooltip>
          ),
        },
        {
          title: "Job Type",
          dataIndex: "JobType",
          key: "JobType",
          showSorterTooltip: false,
          sorter: (a, b) => a.JobCategory.length - b.JobCategory.length,
          ellipsis: {
            showTitle: false,
          },
          render: (item) => (
            <Tooltip placement="topLeft" title={item}>
              {item}
            </Tooltip>
          ),
        },
        {
          title: "Sub Type",
          key: "SubType",
          showSorterTooltip: false,
          sorter: (a, b) => a.SubType.localeCompare(b.SubType),
          ellipsis: {
            showTitle: false,
          },
          render: (item) => (
            <Tooltip placement="topLeft" title={item}>
              {!item.SubType ? "-" : item.SubType}
            </Tooltip>
          ),
        },
        {
          title: "Work Center",
          dataIndex: "WorkCenter",
          key: "WorkCenter",
          showSorterTooltip: false,
          sorter: (a, b) => a.WorkCenter.length - b.WorkCenter.length,
          ellipsis: {
            showTitle: false,
          },
          render: (item) => (
            <Tooltip placement="topLeft" title={item}>
              {item}
            </Tooltip>
          ),
        },
        {
          title: "SLA Level",
          dataIndex: "SlaLevel",
          key: "SlaLevel",
          showSorterTooltip: false,
          sorter: (a, b) => a.SlaLevel.length - b.SlaLevel.length,
        },
        {
          title: "Remain",
          dataIndex: "RemainSLA_Sec",
          align: "center",
          render: (data) => {
            if (data < 0) {
              return "-";
            } else {
              return this.convertSeconds(data);
            }
          },
        },
        {
          title: "Remark",
          dataIndex: "IsReopen",
          key: "IsReopen",
          showSorterTooltip: false,
          sorter: (a, b) => a.IsReopen.length - b.IsReopen.length,
          ellipsis: {
            showTitle: false,
          },
          render: (item) => (
            <Tooltip placement="topLeft" title={item}>
              {item ? "Dtac Reopen" : "-"}
            </Tooltip>
          ),
        },
        {
          title: "Action",
          width: 150,
          align: "center",
          render: (item) => (
            <div>
              {this.state.active === 2 || this.state.active === 3 ? (
                "-"
              ) : (
                <button
                  className="btn-sm btn-success"
                  onClick={() => {
                    if (this.state.tabStatus === "Wait Review Reject") {
                      this.loadDataReview(item);
                    } else {
                      localStorage.setItem("CheckReopen", item.IsReopen);
                      window.location.assign(
                        "/MaxiOperation/CreateJob/" +
                          Cookies.get("companyid") +
                          "/" +
                          Cookies.get("operator_id") +
                          "/" +
                          item.project_id +
                          "/" +
                          item.Id
                      );
                    }
                  }}
                  style={{
                    backgroundColor: "#e8cd00",
                    color: "#fff",
                    border: "1px solid #e8cd00",
                    margin: "2px 0px !important",
                  }}
                >
                  <img
                    src={Api.absoluteUrl("/icon/approve.svg")}
                    className="mr-2"
                  />
                  Wait Review
                </button>
              )}
            </div>
          ),
        },
      ],
      columnsNotMap: [
        {
          title: "Incident ID",
          dataIndex: "so_id",
          key: "so_id",
          sorter: (a, b) => a.so_id.length - b.so_id.length,
        },
        {
          title: "Job Category",
          dataIndex: "JobCategory",
          key: "JobCategory",
          sorter: (a, b) => a.JobCategory.localeCompare(b.JobCategory),
          ellipsis: {
            showTitle: false,
          },
          render: (item) => (
            <Tooltip placement="topLeft" title={item}>
              {item}
            </Tooltip>
          ),
        },
        {
          title: "Job Type",
          dataIndex: "JobType",
          key: "JobType",
          sorter: (a, b) => a.JobCategory.length - b.JobCategory.length,
          ellipsis: {
            showTitle: false,
          },
          render: (item) => (
            <Tooltip placement="topLeft" title={item}>
              {item}
            </Tooltip>
          ),
        },
        {
          title: "Sub Type",
          key: "SubType",
          showSorterTooltip: false,
          sorter: (a, b) => a.SubType.localeCompare(b.SubType),
          ellipsis: {
            showTitle: false,
          },
          render: (item) => (
            <Tooltip placement="topLeft" title={item}>
              {!item.SubType ? "-" : item.SubType}
            </Tooltip>
          ),
        },
        {
          title: "Work Center",
          dataIndex: "WorkCenter",
          key: "WorkCenter",
          sorter: (a, b) => a.WorkCenter.length - b.WorkCenter.length,
          ellipsis: {
            showTitle: false,
          },
          render: (item) => (
            <Tooltip placement="topLeft" title={item}>
              {item}
            </Tooltip>
          ),
        },
        {
          title: "SLA Level",
          dataIndex: "SlaLevel",
          key: "SlaLevel",
          sorter: (a, b) => a.SlaLevel.length - b.SlaLevel.length,
        },
        {
          title: "Field Not Match",
          dataIndex: "FieldNotMatch",
          key: "FieldNotMatch",
          sorter: (a, b) => a.FieldNotMatch.length - b.FieldNotMatch.length,
        },
        {
          title: "Remark",
          dataIndex: "IsReopen",
          key: "IsReopen",
          sorter: (a, b) => a.IsReopen.length - b.IsReopen.length,
          ellipsis: {
            showTitle: false,
          },
          render: (item) => (
            <Tooltip placement="topLeft" title={item}>
              {item ? "Dtac Reopen" : "-"}
            </Tooltip>
          ),
        },
        {
          title: "Action",
          width: 300,
          align: "center",
          render: (item) => (
            <div>
              <button
                className="btn-sm btn-success"
                onClick={() => {
                  if (this.state.tabStatus === "Wait Review Reject") {
                    this.loadDataReview(item);
                  } else {
                    window.location.assign(
                      "/MaxiOperation/CreateJob/" +
                        Cookies.get("companyid") +
                        "/" +
                        Cookies.get("operator_id") +
                        "/" +
                        item.project_id +
                        "/" +
                        item.Id
                    );
                  }
                }}
                style={{
                  backgroundColor: "#e8cd00",
                  color: "#fff",
                  border: "1px solid #e8cd00",
                  margin: "2px 0px !important",
                }}
              >
                <img
                  src={Api.absoluteUrl("/icon/approve.svg")}
                  className="mr-2"
                />
                Wait Review
              </button>
              <button
                className="btn-sm btn-success"
                style={{
                  backgroundColor: "#000f9f",
                  color: "#fff",
                  border: "1px solid #000f9f",
                  margin: "2px 0px !important",
                }}
                onClick={() => this.onSetDataRaw(item)}
              >
                <img
                  src={Api.absoluteUrl("/icon/approve.svg")}
                  className="mr-2"
                />
                Raw Data
              </button>
            </div>
          ),
        },
      ],
      columnsWaitReview: [
        {
          title: "Incident ID",
          dataIndex: "so_id",
          key: "so_id",
          sorter: (a, b) => a.so_id.length - b.so_id.length,
        },
        {
          title: "Job No",
          dataIndex: "job_no",
          key: "job_no",
          sorter: (a, b) => a.job_no.length - b.job_no.length,
          ellipsis: {
            showTitle: false,
          },
        },
        {
          title: "Reason",
          dataIndex: "Reason",
          key: "Reason",
          sorter: (a, b) => a.Reason.length - b.Reason.length,
          ellipsis: {
            showTitle: false,
          },
        },
        {
          title: "Action",
          width: 300,
          align: "center",
          render: (item) => (
            <div>
              <button
                className="btn-sm btn-success"
                onClick={() => {
                  if (this.state.tabStatus === "Wait Review Reject") {
                    this.loadDataReview(item);
                  } else {
                    window.location.assign(
                      "/MaxiOperation/CreateJob/" +
                        Cookies.get("companyid") +
                        "/" +
                        Cookies.get("operator_id") +
                        "/" +
                        item.project_id +
                        "/" +
                        item.Id
                    );
                  }
                }}
                style={{
                  backgroundColor: "#e8cd00",
                  color: "#fff",
                  border: "1px solid #e8cd00",
                  margin: "2px 0px !important",
                }}
              >
                <img
                  src={Api.absoluteUrl("/icon/approve.svg")}
                  className="mr-2"
                />
                Wait Review
              </button>
              {/* <button
                className="btn btn-success"
                style={{backgroundColor: "#000f9f" , color : "#fff" , border: "1px solid #000f9f"}}
              // onClick={() => this.onApprove(item)}
              >
                <img
                  src={Api.absoluteUrl("/icon/approve.svg")}
                  className="mr-2"
                />
                Raw Data
              </button> */}
            </div>
          ),
        },
      ],
      data: [],
      original_data: [],
      status_cancel: false,
      total: [],
      display_load: false,
      loading: true,
      filterTable: "",
      form: {},
      master_reject: [],
      text_modal: "",
      modalstatus: false,
      loadingPage: true,
      PageSize: 40,
      PageIndex: 1,
      totalPage: 0,
      tabStatus: "Create",
      visibleMoal: false,
      reasonText: "",
      imageList: [],
      setDataEvent: [],
      valueRadio: true,
      modalRaw: false,
      rawData: [],
      selectJobType: [],
      selectJobSubType: [],
      selectAssignedGroup: [],
      valueJobType: null,
      valueJobSubType: null,
      valueAssignedGroup: null,
      job_category_id: null,
      cancelTokenJobList: null,
      cancelTokenJobListCount: null,
      loadingJobListCount: true,
    };
  }

  updateDimensions = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
    console.log({ width: window.innerWidth, height: window.innerHeight });
  };

  convertSeconds = (seconds) => {
    // Calculate the number of days
    const days = Math.floor(seconds / (24 * 3600));
    seconds %= 24 * 3600;

    // Calculate the number of hours
    const hours = Math.floor(seconds / 3600);
    seconds %= 3600;

    // Calculate the number of minutes
    const minutes = Math.floor(seconds / 60);

    // Remaining seconds
    const remainingSeconds = seconds % 60;

    // Format the result
    return `${days > 0 ? `${days} days` : ""}${
      hours > 0 ? ` ${hours} hours` : ""
    }${minutes > 0 ? ` ${minutes} minutes` : ""}`;
  };

  async componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions);
    document.title = this.state.title;
    this.LoadData({
      value: this.getQueryTabStatus(),
      pageIndex: this.getQueryPageIndex(),
    });
    this.setState({ active: this.getQueryActiveTab() });
    // this.oncount();
    setInterval(() => {
      this.LoadData({ value: this.state.tabStatus });
    }, 60000);
  }

  // componentWillUnmount() {
  //   window.removeEventListener("resize", this.updateDimensions);
  // }

  onView(id) {
    this.setState({
      visible: true,
      asset_id: id,
    });
  }

  oncount = async ({ value, searchText = "" }) => {
    if (this.state.cancelTokenJobListCount) {
      this.state.cancelTokenJobListCount.cancel("Canceling previous request");
    }
    const source = axios.CancelToken.source();
    this.setState({ cancelTokenJobListCount: source });

    try {
      const total_inform = await Api.postWithCancel(
        "JobItsm/GetOpenJobListCount",
        {
          CompanyId: Cookies.get("companyid"),
          OperatorId: Cookies.get("operator_id"),
          ProjectId: this.getProjectId(),
          SearchText: searchText, //"",
        },
        {
          cancelToken: source.token,
        }
      );
      if (total_inform.data.result.code === "P") {
        const result = total_inform.data.data.filter(
          (data) => data.status === value
        );
        this.setState({
          totalPage: result[0]["count"],
          total: total_inform.data.data,
          loading: false,
        });
      } else {
        console.log("Api Error");
      }
    } catch (error) {
      if (axios.isCancel(error)) {
        // Handle the cancellation
        console.log("Request canceled:", error.message);
      } else {
        console.log("Api Error");
      }
    } finally {
      this.setState({ loadingJobListCount: false });
    }
  };

  setDataTab = async (index, value) => {
    let pathname = this.props.location.pathname;
    let searchParams = new URLSearchParams(this.props.location.search);

    searchParams.set("tab", value);
    searchParams.set("activeTab", index);
    this.props.history.push({
      pathname: pathname,
      search: searchParams.toString(),
    });

    this.LoadData({ value: value, pageIndex: 1 });
    this.setState({
      active: index,
      loadingJobListCount: true,
    });
  };

  dateFormat(item) {
    return !item ? "-" : moment(item).format("DD/MM/YYYY HH:mm");
  }

  search = (value, _e, info) => {
    console.log("search", info?.source, value);
    // const { data, tab } = this.state;
    // var index = 0;
    // var setdata = [];
    // var obj = {};
    // for (let i = 0; i < data.length; i++) {
    //   for (const [key, value] of Object.entries(data[i])) {
    //     // if (`${key}` !== "inform_job_id") {
    //     if (value == null || value == undefined) {
    //       obj[`${key}`] = "-";
    //     } else {
    //       obj[`${key}`] = `${value}`;
    //     }
    //     // }
    //   }
    //   setdata.push(obj);
    //   setdata.push(index++);
    //   obj = {};
    // }

    // const filterTable = setdata.filter((o) =>
    //   Object.keys(o).some((k) =>
    //     String(o[k]).toLowerCase().includes(value.toLowerCase())
    //   )
    // );
    this.setState({
      filterTable: value,
      loading: true,
      loadingJobListCount: true,
    });
    this.LoadData({
      value: this.state.tabStatus,
      searchText: value,
      pageIndex: 1,
    });
  };

  CreateJob = async (item) => {
    localStorage.setItem("informDetail", JSON.stringify(item));
    localStorage.setItem("StatusLocal", 2);
    setTimeout(function () {
      window.location.assign("/MaxiOperation/editjob");
    }, 1000);
  };
  CreateJobAuto = async (item) => {
    this.setState({
      loadingPage: false,
    });
    const cancelInform = await Api.post("create_oper_job_by_inform", [
      {
        inform_job_id: item.inform_job_id,
        inform_job_no: item.inform_job_no,
        emp_id: Cookies.get("userId"),
      },
    ]);

    if (cancelInform.data.result.code === "P") {
      this.setState({
        loadingPage: true,
      });
      this.setState({
        text_modal: "Create Inform",
        modalstatus: true,
      });
    } else {
      alert("ไม่สามารถสร้างงานแบบอัตโนมัติได้ !!!");
      this.setState({
        loadingPage: true,
      });
    }
  };

  CancelInform = async (item) => {
    const cancelInform = await Api.post("tab_update_inform_approve", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: this.getProjectId(),
      inform_job_id: item.inform_job_id,
      flag_approve: 2,
      create_by: Cookies.get("username"),
      service_ma_reason_id: this.state.form["Reason"],
      approve_remark: this.state.form["remark"],
    });
    if (cancelInform.data.result.code === "P") {
      this.setState({
        text_modal: "Cancel Inform",
        modalstatus: true,
      });
    }
  };
  onApprove = async (item) => {
    this.setState({
      loadingPage: false,
    });
    // console.log(item);
    const tab_update_inform_approve = await Api.post(
      "tab_update_inform_approve",
      {
        company_id: Cookies.get("companyid"),
        operator_id: Cookies.get("operator_id"),
        project_id: this.getProjectId(),
        inform_job_id: item.inform_job_id,
        flag_approve: 1,
        create_by: Cookies.get("userId"),
      }
    );
    if (tab_update_inform_approve.data.result.code === "P") {
      this.setState({
        loadingPage: true,
      });
      this.setState({
        text_modal: "Approve Inform",
        modalstatus: true,
      });
    } else {
      alert("Approve ไม่สำเร็จ");
    }
  };
  renderCancel() {
    return (
      <Modal
        title={null}
        centered
        visible={this.state.status_cancel}
        footer={null}
        closable={true}
        onCancel={() =>
          this.setState({
            status_cancel: false,
          })
        }
      >
        <div className="text-center">
          <h3 className="font-mont-sb font18 c-blue mt-3">Cancel Job</h3>
          <div className="row mt-3 mb-2">
            <div className="col-3">
              {" "}
              <span>Reason : </span>
            </div>
            <div className="col-7">
              <Select
                style={{ border: "0px", textAlign: "left" }}
                placeholder="Select a Reason"
                className="inputfile"
                onChange={(value) => (this.state.form["Reason"] = value)}
              >
                {this.state.master_reject.map((item, index) => (
                  <Select.Option value={item.service_ma_reason_id} key={index}>
                    {item.service_ma_reason_desc}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-3">
              {" "}
              <span>Remark : </span>
            </div>
            <div className="col-7">
              <textarea
                style={{ width: "100%", height: "60px" }}
                name="inform_remark"
                onChange={(e) => (this.state.form["remark"] = e.target.value)}
              ></textarea>
            </div>
          </div>
          <button
            onClick={() => this.CancelInform()}
            className="btn btn-secondary"
          >
            OK
          </button>
        </div>
      </Modal>
    );
  }

  addQuery = (key, value) => {
    let pathname = this.props.location.pathname;
    // returns path: '/app/books'
    let searchParams = new URLSearchParams(this.props.location.search);
    // returns the existing query string: '?type=fiction&author=fahid'
    searchParams.set(key, value);
    this.props.history.push({
      pathname: pathname,
      search: searchParams.toString(),
    });
  };

  getProjectId = () => {
    const urlParams = new URLSearchParams(this.props.location.search);
    const keyProjectId = urlParams.get("projectId");
    if (keyProjectId !== null) {
      return keyProjectId === "" ? null : keyProjectId;
    } else {
      const filterProjectdata = JSON.parse(
        localStorage.getItem("projectData")
      ).filter((data) => {
        return data.operator_id == Cookies.get("operator_id");
      });
      return filterProjectdata[0]?.project_id;
    }
  };

  getQueryTabStatus = () => {
    const urlParams = new URLSearchParams(this.props.location.search);
    const keyTabStatus = urlParams.get("tab");
    if (keyTabStatus !== null) {
      return keyTabStatus === "" ? "Create" : keyTabStatus;
    } else {
      return "Create";
    }
  };

  getQueryActiveTab = () => {
    const urlParams = new URLSearchParams(this.props.location.search);
    const keyActiveTab = urlParams.get("activeTab");
    if (keyActiveTab !== null) {
      return keyActiveTab === "" ? 0 : Number(keyActiveTab);
    } else {
      return 0;
    }
  };

  getQueryPageIndex = () => {
    const urlParams = new URLSearchParams(this.props.location.search);
    const keyPageIndex = urlParams.get("page");
    if (keyPageIndex !== null) {
      return keyPageIndex === "" ? 1 : Number(keyPageIndex);
    } else {
      return 1;
    }
  };

  LoadData = async ({
    value = this.state.tabStatus,
    searchText = "",
    pageIndex = this.state.PageIndex,
  }) => {
    if (this.state.cancelTokenJobList) {
      this.state.cancelTokenJobList.cancel("Canceling previous request");
    }
    const source = axios.CancelToken.source();
    this.setState({ cancelTokenJobList: source, PageIndex: pageIndex });

    const ListData = await Api.post(
      "JobItsm/GetOpenJobList",
      {
        CompanyId: Cookies.get("companyid"),
        OperatorId: Cookies.get("operator_id"),
        ProjectId: this.getProjectId(),
        Status: value,
        SearchText: searchText, //this.state.filterTable,
        PageSize: this.state.PageSize,
        PageIndex: pageIndex,
      },
      {
        cancelToken: source.token,
      }
    );
    if (ListData.data.result.code === "P") {
      this.oncount({ value, searchText });
      this.setState({
        tabStatus: value,
        data: ListData.data.data,
        loading: false,
      });
    } else {
      console.log("Api Error");
    }
  };
  onChangePage = (page, pageSize) => {
    this.addQuery("page", page);
    this.setState({
      PageSize: pageSize,
      loading: true,
    });
    this.LoadData({ pageIndex: page });
  };
  loadDataReview = async (value) => {
    const GetOperJobReject = await Api.get(
      "JobItsm/GetOperJobReject/" + value.job_reject_id
    );
    if (GetOperJobReject.data.result.code === "P") {
      this.onLoadDataReject(value.job_id);

      this.setState({
        imageList: GetOperJobReject.data.data.operPics,
        reasonText: GetOperJobReject.data.data.jobReject.reason,
        setDataEvent: GetOperJobReject.data.data,
        loading: false,
        visibleMoal: true,
      });

      await this.onLoadMasterGetAssignedGroup();
    } else {
      alert(" No Data ");
    }
  };
  onReject = async () => {
    const MccApproveReject = await Api.post("JobItsm/MccApproveReject", {
      SoId: this.state.setDataEvent.jobReject.soId,
      JobRejectId: this.state.setDataEvent.jobReject.jobRejectId,
      CompanyId: this.state.setDataEvent.jobReject.companyId,
      OperatorId: this.state.setDataEvent.jobReject.operatorId,
      ProjectId: this.state.setDataEvent.jobReject.projectId,
      JobId: this.state.setDataEvent.jobReject.jobId,
      IsApprove: false,
      UserId: Cookies.get("userId"),
      Username: Cookies.get("username"),
      UsergroupId: Cookies.get("usergroup_id"),
      UsergroupName: Cookies.get("usergroupname"),
    });
    if (MccApproveReject.data.result.code === "P") {
      message.success("Reject data success");
      this.setState({ visibleMoal: false });
      this.LoadData({ value: this.state.tabStatus });
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } else {
      message.success("Reject data Fail");
    }
  };
  onApprove = async () => {
    const MccApproveReject = await Api.post("JobItsm/MccApproveReject", {
      SoId: this.state.setDataEvent.jobReject.soId,
      JobRejectId: this.state.setDataEvent.jobReject.jobRejectId,
      CompanyId: this.state.setDataEvent.jobReject.companyId,
      OperatorId: this.state.setDataEvent.jobReject.operatorId,
      ProjectId: this.state.setDataEvent.jobReject.projectId,
      JobId: this.state.setDataEvent.jobReject.jobId,
      IsApprove: true,
      UserId: Cookies.get("userId"),
      Username: Cookies.get("username"),
      UsergroupId: Cookies.get("usergroup_id"),
      UsergroupName: Cookies.get("usergroupname"),
    });
    const RejectJobItsm = await Api.post("JobItsm/RejectJobItsm", {
      so_id: this.state.setDataEvent.jobReject.soId,
      Assignee: Cookies.get("userITSM"),
      project_id: this.state.setDataEvent.jobReject.projectId,
      IsCreateTask: this.state.valueRadio,
      job_id: this.state.setDataEvent.jobReject.jobId,
      AssignedGroup: this.state.valueAssignedGroup,
      job_type_id: this.state.valueJobType,
      job_sub_type_id: this.state.valueJobSubType,
    });
    if (
      MccApproveReject.data.result.code === "P" &&
      RejectJobItsm.data.result.code === "P"
    ) {
      message.success("Reject data success");
      this.setState({ visibleMoal: false });
      this.LoadData({ value: this.state.tabStatus });
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } else {
      message.success("Reject data Fail");
    }
  };
  onSetDataRaw = (item) => {
    var setDisplayModal = [];
    console.log(JSON.parse(item.RawData));
    var setObj = JSON.parse(item.RawData);
    for (const property in setObj) {
      setDisplayModal.push({
        text: property,
        value: !setObj[property] ? "-" : setObj[property],
      });
    }
    this.setState({
      rawData: setDisplayModal,
      modalRaw: true,
    });
  };
  onLoadMasterJobType() {
    Api.post("V4/get_job_type", {
      pk_id: null,
      fk_id: this.state.job_category_id,
      is_active: "1",
      effective: "1",
      sql_where: null,
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: this.getProjectId(),
      UserName: Cookies.get("username"),
    })
      .then((response) => {
        var setData = [];
        for (let i = 0; i < response.data.data.length; i++) {
          setData.push({
            value: response.data.data[i]["job_type_id"],
            label: response.data.data[i]["job_type_name"],
          });
        }
        this.setState({
          selectJobType: setData,
        });
      })
      .catch((e) => {
        console.log(e);
      });
  }
  onLoadMasterGetAssignedGroup() {
    Api.get(
      "JobMaxi/GetAssignedGroup/" + this.state.setDataEvent.jobReject.projectId
    )
      .then((response) => {
        var setData = [];
        for (let i = 0; i < response.data.data.length; i++) {
          setData.push({
            value: response.data.data[i]["AssignedGroupName"],
            label: response.data.data[i]["AssignedGroupName"],
          });
        }
        this.setState({
          selectAssignedGroup: setData,
        });
      })
      .catch((e) => {
        console.log(e);
      });
  }
  onLoadMasterJobSub(value) {
    Api.post("get_job_sub_type", {
      job_sub_type_id: null,
      job_category_id: this.state.job_category_id,
      job_type_id: value,
      is_active: 1,
      effective: 1,
      sql_where: " and company_id=" + Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
    })
      .then((response) => {
        var setData = [];
        for (
          let i = 0;
          i < response.data.data.job_sub_type_dto_list.length;
          i++
        ) {
          setData.push({
            value:
              response.data.data.job_sub_type_dto_list[i]["job_sub_type_id"],
            label: response.data.data.job_sub_type_dto_list[i]["job_type_name"],
          });
        }
        this.setState({
          selectJobSubType: setData,
        });
      })
      .catch((e) => {
        console.log(e);
      });
  }
  onLoadDataReject(job_id) {
    Api.get("JobMaxi/GetOperTierJobOper/" + job_id)
      .then((response) => {
        this.setState({
          valueJobType: response.data.data.job_type_id,
          valueJobSubType: response.data.data.job_sub_type_id,
        });
        this.setState({
          job_category_id: response.data.data.job_category_id,
        });
        this.onLoadMasterJobType();
        this.onLoadMasterJobSub(response.data.data.job_type_id);
      })
      .catch((e) => {
        console.log(e);
      });
  }
  render() {
    const { title, active, tab, filterTable } = this.state;
    return (
      <LayoutOperationNewJob active={3}>
        <Spin
          spinning={!this.state.loadingPage}
          size="large"
          style={{ marginTop: "16%" }}
        >
          <div
            className="wrapper-header-1 d-flex align-items-center"
            style={{ height: 50 }}
          >
            <div className="container-fluid">
              <div className="row align-items-center">
                <div
                  // className="col-3"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <img
                      src={Api.absoluteUrl("/icon/menu_inform_white.svg")}
                      className="mr-2"
                      style={{ width: "22px", height: "22px" }}
                    />
                    <h2
                      className="c-white text-uppercase m-0 d-inline-block font-mont-b font20"
                      style={{ width: 200 }}
                    >
                      {title}
                    </h2>
                  </div>
                  <div>
                    <Input.Group compact>
                      <Input.Search
                        placeholder="Search"
                        onSearch={this.search}
                        // onSearch = {(value, _e, info) => console.log(info?.source, value)}
                        style={{ width: "335px" }}
                        enterButton
                      />
                    </Input.Group>
                  </div>
                </div>
                {/* <div className="col-6">
                  <div className="row justify-content-center">
                    <div className="col-3">
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="font-thai-b c-white font14"></span>
                      </div>
                    </div>
                    <div className="col-3 offset-1">
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="font-thai-b c-white font14"></span>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
          <div className="wrapper-body" style={{ marginTop: 10 }}>
            <div
              className="container-fluid"
              style={{ paddingLeft: 10, paddingRight: 10 }}
            >
              {/* <div className="my-2 d-flex align-items-center justify-content-between row">
                <div className="col-12" style={{ paddingLeft: 0 }}>
                  <div className="d-flex row">
                    <div className="col-10" style={{ paddingLeft: 10 }}>
                      <Input.Group compact>
                        <Input.Search
                          placeholder="Search"
                          onSearch={this.search}
                          // onSearch = {(value, _e, info) => console.log(info?.source, value)}
                          style={{ width: "335px" }}
                          enterButton
                        />
                      </Input.Group>
                    </div>
                  </div>
                </div>
              </div> */}
              <div className="card-table-ma">
                <ul className="nav">
                  {tab.map((item, index) => (
                    <li
                      key={index}
                      className="nav-item font12 font-mont-sb mr-1"
                    >
                      <Spin
                        indicator={<LoadingOutlined spin />}
                        spinning={this.state.loadingJobListCount}
                        size="small"
                      >
                        <a
                          disabled={this.state.loadingJobListCount}
                          className={
                            active === index ? "nav-link active" : "nav-link"
                          }
                          onClick={() =>
                            this.setDataTab(
                              index,
                              this.state.total[index].status
                            )
                          }
                        >
                          {this.state.total.length === 0
                            ? "-"
                            : String(this.state.total[index].status).replace(
                                "Create",
                                "Reopen"
                              )}
                          {" ("}
                          {this.state.total.length === 0
                            ? 0
                            : this.state.total[index].count}
                          {") "}
                        </a>
                      </Spin>
                    </li>
                  ))}
                </ul>
                <div className="ma-table" style={{ padding: "5px" }}>
                  <Table
                    size="small"
                    loading={this.state.loading}
                    columns={
                      this.state.active === 1
                        ? this.state.columnsNotMap
                        : this.state.active === 4
                        ? this.state.columnsWaitReview
                        : this.state.active === 5
                        ? this.state.columnsHold
                        : this.state.columns
                    }
                    //  columns={this.state.columns}
                    pagination={false}
                    scroll={{ y: this.state.height - 230 }}
                    rowKey="inform_job_id"
                    dataSource={this.state.data}
                  />
                  {/* <Spin
                    indicator={<LoadingOutlined spin />}
                    spinning={this.state.loadingJobListCount}
                    size="small"
                  > */}
                  {!this.state.loadingJobListCount && (
                    <Pagination
                      showSizeChanger={false}
                      defaultPageSize={40}
                      defaultCurrent={this.state.PageIndex}
                      total={this.state.totalPage}
                      className="m-2"
                      style={{ float: "right" }}
                      onChange={(page, pageSize) =>
                        this.onChangePage(page, pageSize)
                      }
                    />
                  )}

                  {/* </Spin> */}
                </div>
                {/* <div style={{ marginTop: 5, marginBottom: 5, float: "right" }}>
                  <Pagination
                    defaultCurrent={this.state.PageIndex}
                    total={this.state.totalPage}
                    onChange={(page, pageSize) =>
                      this.onChangePage(page, pageSize)
                    }
                  />
                  <br />
                </div> */}
              </div>
            </div>
          </div>
        </Spin>

        <Modal
          title="Wait Review Reject"
          visible={this.state.visibleMoal}
          footer={false}
          onCancel={() => this.setState({ visibleMoal: false })}
        >
          <div className="row">
            <div className="col-4">
              <span>Reason</span>
            </div>
            <div className="col-8">
              <Input
                placeholder="Reason"
                value={this.state.reasonText}
                disabled
              />
            </div>
            <div className="col-4 mt-3">
              <span>Image</span>
            </div>
            <div className="col-8 mt-3">
              {this.state.imageList.map((item) => (
                <Image
                  width={150}
                  height={80}
                  src={Api.checkPath(item.pic_url_path, item.pic_upload_name)}
                ></Image>
              ))}
            </div>

            <div className="col-6">
              <span className="float-left mb-2">{"Job Type"}</span>
              <br />
              <Select
                size={"middle"}
                placeholder="Please select"
                value={this.state.valueJobType}
                onChange={(e) => this.setState({ valueJobType: e })}
                style={{
                  width: "100%",
                }}
                options={this.state.selectJobType}
              />
            </div>
            <div className="col-6">
              <span className="float-left mb-2">{"Job Sub Type"}</span>
              <br />
              <Select
                size={"middle"}
                value={this.state.valueJobSubType}
                placeholder="Please select"
                onChange={(e) => this.setState({ valueJobSubType: e })}
                style={{
                  width: "100%",
                }}
                options={this.state.selectJobSubType}
              />
            </div>
            <div className="col-12 mt-2 mb-2">
              <span className="float-left mb-2">{"Assigned Group Name"}</span>
              <br />
              <Select
                size={"middle"}
                value={this.state.valueAssignedGroup}
                placeholder="Please select"
                onChange={(e) => this.setState({ valueAssignedGroup: e })}
                style={{
                  width: "100%",
                }}
                options={this.state.selectAssignedGroup}
              />
            </div>
            <div className="col-12 mt-3">
              <Radio.Group
                name="radiogroup"
                defaultValue={this.state.valueRadio}
                onChange={(e) => this.setState({ valueRadio: e.target.value })}
              >
                <Radio value={true}>สร้าง Task ITSM</Radio>
                <Radio value={false}>ไม่สร้าง Task ITSM</Radio>
              </Radio.Group>
            </div>
            <div className="col-12 mt-3" style={{ textAlign: "right" }}>
              <button
                type="button"
                class="btn btn-danger"
                onClick={() => this.onReject()}
              >
                Reject
              </button>
              <button
                type="button"
                className="btn btn-success"
                onClick={() => this.onApprove()}
              >
                Approve
              </button>
            </div>
          </div>
        </Modal>

        <Modal
          title="Raw Data"
          footer={false}
          visible={this.state.modalRaw}
          width={1000}
          onCancel={() => this.setState({ modalRaw: false })}
        >
          <div className="row">
            {this.state.rawData.map((item) => (
              <>
                <div className="col-3 mb-2">
                  <p>{item.text}</p>
                  <Input placeholder="Reason" value={item.value} />
                </div>
                {/* <div className="col-3 mb-2"></div> */}
              </>
            ))}
          </div>
        </Modal>
      </LayoutOperationNewJob>
    );
  }
}

export default InformList;
